import axios from "axios";

// Create an axios instance with default configuration
const api = axios.create({
  baseURL: "http://localhost:3001", // Replace with your actual backend URL
  timeout: 10000, // Set a timeout of 10 seconds (adjust as needed)
  headers: {
    "Content-Type": "application/json",
    // 'Authorization': `Bearer ${localStorage.getItem('token')}` // Add authorization header if necessary
  },
});

// Define helper functions for common request types
export async function get(endpoint, params = {}) {
  const response = await api
    .get(endpoint, { params })
    .then((response) => response.data)
    .catch((error) => {
      return onResolverResponse(error);
    });
  return response;
}

export async function post(endpoint, data) {
  const response = api
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      return onResolverResponse(error);
    });
  return response;
}

export async function put(endpoint, data) {
  const response = api
    .put(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      return onResolverResponse(error);
    });
  return response;
}

export async function del(endpoint, params = {}) {
  const response = await api
    .delete(endpoint, { params })
    .then((response) => response.data)
    .catch((error) => {
      return onResolverResponse(error);
    });
  return response;
}

function onResolverResponse(response) {
  if (!response || !response.json) return { error: true, ...response };
  //probably not needed all below
  var p1 = response.json();
  p1.then((responseData, error) => {
    if (response.status !== 200 || error) {
      return { error: true, error, responseData };
    } else {
      return responseData;
    }
  });
}
